<template>
  <div class="login flexR cenX ">
    <div class="centBox">
      <div class="tit flexR cenY cenX mb col">
        <img src="../../../static/img/logo.png" alt="" style="margin-right: 10px;height: 46px;">
        业务中台
      </div>
      <div class="flexC">
        <a-input
          size="large"
          allowClear
          v-model="loginForm.name"
          style="width: 320px;margin-bottom: 18px;"
          placeholder='请输入账号'>
          <a-icon slot="prefix" type="user" />
        </a-input>
        <a-input
          size="large"
          allowClear
          type="password"
          v-model="loginForm.pass"
          style="width: 320px;margin-bottom: 24px;"
          placeholder="请输入密码">
          <a-icon slot="prefix" type="lock" />
        </a-input>
      </div>
      <div class="flexR cenX mb">
        <div class="flex">
          <a-checkbox size="large" style="color: #fff" >记住密码</a-checkbox>
        </div>
        <div class="flex col register" @click="registerFun" style="opacity: 0">没有账号？注册</div>
      </div>
      <a-button
        class="col"
        size="large"
        :loading="loading"
        style="width: 100%;font-size: 18px;letter-spacing: 5px;" type="primary"
        @click="loginFun">登录</a-button>
    </div>
  </div>
</template>

<script>
import GlobalFooter from "../../layouts/GlobalFooter";
import { setLogin } from "../../api.js";
import B from './Secret/BigInt'
import R from './Secret/RSA'

export default {
  name: "Login",
  components: { GlobalFooter },
  data() {
    return {
      loading: false,
      loginForm: {
        name: '',
        pass: ''
      }
    };
  },
  computed: {

  },
  created() {

  },
  methods: {
    registerFun(){},
    loginFun(){
      if(this.loading) return
      if(!this.loginForm.name.trim()){
        this.$message.info('请填写账号')
      }else if(!this.loginForm.pass.trim()){
        this.$message.info('请填写密码')
      }else {
        this.loading = true
        B.setMaxDigits(129)
        const key = new R.RSAKeyPair('010001', '', 'DBCC53814668BD44D2185B1195A00C5222DAB190AEF5397E6466918D560337ECA438CF8725BA35A2F38B79BC7C1A441ED610D361B990008A47B42633C23D6674DC8545032BF161B83FE0E1B7609D1A8DD72B23AEDC60830A1614D9A7D22A3419FC9616BA858FC9D2D4A390B6A4D3CE5488CAD6F4264A1412E5E30FF372C80515')
        const password = R.encryptedString(key, this.loginForm.pass)
        setLogin({
          loginName: this.loginForm.name,
          password: password,
          productId: 2,
        }).then(res=>{
          if(res.error){
            this.$message.info(res.error.data.message)
          }else {
            localStorage.setItem('LOGIN_ACCESS_TOKEN', res.result.sessionKey)
            localStorage.setItem('ACCESS_TOKEN', res.result.sessionKey)
            this.$store.commit('SET_INFO', JSON.stringify(res.result.user))
          }
        }).finally(()=> {
          this.loading = false
          this.$router.push({path: '/'})
        })
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.login {
  height: 100%;
  background: url("../../../static/img/login.png") center no-repeat;
  background-size: 100% 100%;
  .centBox {
    .tit {
      font-weight: 600;
      font-size: 30px;
      padding-bottom: 5px;
      letter-spacing: 2px;
    }
    padding-top: 210px;
    .register {
      text-align: right;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        color: #409eff;
      }
    }
  }
}
.mb {
  margin-bottom: 26px;
}
.col {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue